/**
 * Input Schema of StatusCarga
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {StatusCarga} from '@/model/resource/StatusCarga'

/* TODO: review generated schema */
export class InputStatusCargaSchema extends Schema {
  readonly name = 'InputStatusCarga'

  readonly fieldSet: FieldSet<StatusCarga> = {
    nome: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 63,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.InputCheckbox,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'pretty p-switch p-fill justify-center mt-8',
        labelClass: 'relative state',
      },
    }),
  }
}
